import * as actionTypes from "./actionTypes";

export const actions = {
  myDeliveriesFetching: () => ({
    type: actionTypes.MY_DELIVERIES_FETCHING,
  }),
  myDeliveriesFetched: (payload) => ({
    type: actionTypes.MY_DELIVERIES_FETCHED,
    payload,
  }),
  myDeliveriesFetchFailed: (payload) => ({
    type: actionTypes.MY_DELIVERIES_FETCHED,
    payload,
  }),
};

const initialState = {
  status: null,
  data: {
    myDeliveries: {},
    nextDeliveries: [],
  },
  loading: true,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.MY_DELIVERIES_FETCHING: {
      return {
        ...state,
        status: actionTypes.STATE_STATUS.FETCHING,
        loading: true,
      };
    }

    case actionTypes.MY_DELIVERIES_FETCHED: {
      return {
        ...state,
        data: {
          ...action.payload,
        },
        loading: false,
        status: actionTypes.STATE_STATUS.FETCHED,
      };
    }
    case actionTypes.MY_DELIVERIES_FETCH_FAILD: {
      return {
        ...state,
        data: {
          ...action.payload,
        },
        loading: false,
        status: actionTypes.STATE_STATUS.FETCH_FAILED,
      };
    }
  }
  return state;
};
reducer.initialState = initialState;

export default reducer;
